import { render } from "./EditProductModal.vue?vue&type=template&id=0ca783ca"
import script from "./EditProductModal.vue?vue&type=script&lang=js"
export * from "./EditProductModal.vue?vue&type=script&lang=js"

import "./EditProductModal.vue?vue&type=style&index=0&id=0ca783ca&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__